/**
 * BusStopContent
 * 
 * @Author: Focci
 * @Date: 2024-09-03 11:15:59
 * @Last Modified by: Focci
 * @Last Modified time: 2024-09-03 11:15:59
 */

import PropTypes from 'prop-types'
import SVGLocationMap from '@img/location-map.svg'
import Link from 'next/link'

export default function BusStopContent({
  data = {}
}) {
  return (
    <div className="flex items-center gap-2">
      <div className="px-3 py-3 max-w-60 flex-auto">
        <div className="text-f.7">{data.code}</div>
        <div className="text-f.8 font-medium">{data.name}</div>
        <div className="text-helper mt-2">bus station</div>
      </div>
      <Link
        href={`https://www.google.com/maps?q=${data.lat},${data.lng}`}
        target="_blank"
      >
        <SVGLocationMap />
      </Link>
    </div>
  )
}

BusStopContent.propTypes = {
  data: PropTypes.object,
}
